import React from 'react';
import { Dialog } from 'primereact/dialog';

function CheckListModal({ visible, onHide, title, inputValue, onInputChange, onSave, loading, isEdit,isValid,setValid }) {
    
    return (
        <Dialog header={title} visible={visible} onHide={onHide}>
            <form onSubmit={(e) => { e.preventDefault(); onSave(); }}>
                <div style={{ width: "34em" }}>
                    <input
                        type="text"
                        name="check_list"
                        value={inputValue}
                        onChange={onInputChange}
                        style={{
                            width: "100%",
                            paddingBottom: "19px",
                            marginBottom: "15px",
                            borderColor: isValid ? 'red'  :  'initial', // Change border color based on error state
                            borderWidth: '1px',
                            borderStyle: 'solid'
                        }}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                        style={{
                            marginRight: "9px",
                            width: "9em",
                            backgroundColor: '#328277',
                            color: "#fff",
                            border: "none",
                            padding: "7px"
                        }}
                        type="submit"
                        disabled={loading} // Disable if loading
                    >
                        {isValid ? 'Saving...' : (isEdit ? 'UPDATE' : 'SAVE')}
                    </button>
                    <button
                        style={{
                            width: "9em",
                            backgroundColor: '#f9ae3b',
                            color: "#fff",
                            border: "none"
                        }}
                        type="button"
                        onClick={onHide}
                    >
                        CLOSE
                    </button>
                </div>
            </form>
        </Dialog>
    );
}

export default CheckListModal